export default {
  account: {
    getStarted: '/account/get-started',
    finalize: '/account/finalize',
    verify: '/account/verify',
    thankYou: '/account/thank-you'
  }
};
